import { createAsyncThunk } from '@reduxjs/toolkit';
import { OtpLogin } from '../../../client/services';
import { CreateCompanyOtpLogin } from './interface';
import { toastHandler } from '../../../utils/toastHandler';

export const createCompanyOtpLogin = createAsyncThunk(
  'companyOtpLogin/createCompanyOtpLogin',
  async (values: CreateCompanyOtpLogin, { rejectWithValue }) => {
    try {
      const response = await OtpLogin.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

